import React from 'react';
import { Animated } from 'react-animated-css';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import Loader from '../../../common/Loader';
import _ from 'lodash';
import Lists from './partials/Lists';
import BatchCoachAssign from './partials/Batch';

class CoachAssign extends React.Component {

  state = {
    bootstrapped: false,
    selectedDivision: null,
    isDivisionsOpen: false,
    fetchingCoaches: false,
    coaches: null,
    mode: 1,
  }

  onRefresh = () => {
    this.fetchQuestionsOfDivision();
    this.fetchCoachesOfDivision();
  }

  // Lifecycle
  componentWillMount() {
    const { setTitle, params } = this.props;
    setTitle && setTitle({
      sub: 'Coach Assign',
      main: this.props.season ? this.props.season.Name : null
    });

    this.props.fetchDivisions && this.props.fetchDivisions(params.idSeason);
    this.props.fetchSeason && this.props.fetchSeason(params.idSeason);
    this.props.seasonActions && this.props.seasonActions.fetchAllCoaches(params.idSeason);
    this.props.seasonActions && this.props.seasonActions.fetchAllTeams(params.idSeason);

  }

  componentWillReceiveProps = (nextProps) => {

    if (nextProps.season !== this.props.season) {

      const { setTitle } = nextProps;
      setTitle && setTitle({
        sub: 'Coach Assign',
        main: nextProps.season.Name || null
      });

      // Fetch the league roles
      this.props.leagueActions &&
        this.props.leagueActions.fetchRoles(nextProps.season.IdLeague);
    }

    if (nextProps.divisions && !this.state.bootstrapped) {
      this.setState({
        bootstrapped: true,
        selectedDivision: _.first(nextProps.divisions)
      }, () => {
        this.onRefresh();
      });
    }

    if (nextProps.coaches) {
      this.setState({
        coaches: nextProps.coaches,
        fetchingCoaches: false
      });
    }
  }
  componentWillUnmount = () => {
    this.props.clearDivisions && this.props.clearDivisions();
    this.props.divisionsActions.clearCoaches && this.props.divisionsActions.clearCoaches(); // TODO: change this one to season actions
    this.props.divisionsActions.clearQuestions && this.props.divisionsActions.clearQuestions();
  }
  //

  fetchQuestionsOfDivision = () => {
    const { selectedDivision } = this.state;
    this.props.divisionsActions && this.props.divisionsActions.fetchQuestions && this.props.divisionsActions.fetchQuestions(selectedDivision.IdDivision, 2);
  }

  fetchCoachesOfDivision = () => {
    const { selectedDivision } = this.state;
    this.props.divisionsActions && this.props.divisionsActions.fetchCoaches(selectedDivision.IdDivision);
  }

  toggleDivisions = () => {
    this.setState({
      isDivisionsOpen: !this.state.isDivisionsOpen
    });
  }

  selectDivision = (selectedDivision) => {
    this.setState({
      selectedDivision,
      isDivisionsOpen: false
    }, () => {
      this.fetchCoachesOfDivision();
      this.fetchQuestionsOfDivision();
    });
  }

  render() {

    const { bootstrapped, selectedDivision, fetchingCoaches, mode = 1 } = this.state,
      { divisions, coaches } = this.props;

    let filteredDivisions = divisions; //_.reject(divisions, d => d.IsTryout);

    return (
      <section>

        <Animated animationInDuration={300} animationOutDuration={300} isVisible={(mode === 1) ? true : false} animateOnMount={false} animationIn="fadeInLeft" animationOut="fadeOutLeft" className="viewport">

          { /* List */}
          {bootstrapped && selectedDivision && coaches && coaches.length > 0 && (
            <Lists {...this.props} selectedDivision={selectedDivision} fetchingCoaches={fetchingCoaches} />)}

          {/* No */}
          {bootstrapped && coaches && !coaches.length && (
            <div key="no-teams" className="d-flex flex-col justify-content-center centered-message">
              <h1 className="black align-self-center block text-center">{`'${selectedDivision.Name}' have no Coaches registered`}</h1>
            </div>)}

          { /* Loader */}
          {(!bootstrapped || fetchingCoaches) && <Loader message="Fetching Assets" />}

          { /* Top left actions */}
          {bootstrapped && (
            <div className="d-flex flex-row w-100" style={{ position: 'absolute', zIndex: 1, top: 0, left: 0, marginTop: 10, paddingLeft: 15, paddingRight: 15 }}>
              { /* Select division dropdown */}
              <span className="align-self-center black margin-right-half font-16">Division</span>
              <Dropdown isOpen={this.state.isDivisionsOpen} toggle={this.toggleDivisions}>
                <DropdownToggle caret className="btn-info btn-sm btn">
                  {selectedDivision.Name} (
                  {selectedDivision.TotalCoaches} requests)
                </DropdownToggle>
                <DropdownMenu>
                  {filteredDivisions && filteredDivisions.map((division, i) => (
                    <DropdownItem key={i} onClick={() => this.selectDivision(division)}>
                      {division.Name} ({division.TotalCoaches} requests)
                    </DropdownItem>))}
                </DropdownMenu>
              </Dropdown>

              {/* Batch Add on the right */}
              <button className="btn btn-info btn-sm ml-auto" onClick={() => this.setState({ mode: 2 })}>
                <i className="fas fa-layer-group mr-2" />Batch Add<i className="fas fa-arrow-right ml-2" />
              </button>
            </div>)}
        </Animated>

        <Animated animationInDuration={300} animationOutDuration={300} isVisible={mode === 2} animateOnMount={false} animationIn="fadeInRight" animationOut="fadeOutRight" className="viewport" >
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1, height: 40 }} className="d-flex flex-row">
            <button className="btn btn-default" onClick={() => this.setState({ mode: 1 })}><i className="fas fa-arrow-left blue" /> Back to Coach Assign</button>
          </div>
          <div style={{ position: 'absolute', top: 40, left: 0, right: 0, bottom: 0 }}>
            <BatchCoachAssign {...this.props} refresh={this.onRefresh} />
          </div>
        </Animated>

      </section>)
  }
}

export default CoachAssign;
